import Menu from "./common/ResponsiveMenu";
import React, { useId, useState } from "react";
import { Button, ListSubheader, MenuItem } from "@mui/material";
import { Check, ExpandMore } from "@mui/icons-material";
import { UsageSource } from "../api/usage";
import { storyLibraryPillButtonSx } from "./common/StoryLibraryControls";
import { APP_ACCENT_GOLD, APP_BORDER, APP_SURFACE, APP_TEXT_SECONDARY } from "./createShared";

export const usageFilterPillSx = {
  ...storyLibraryPillButtonSx(false),
  px: { xs: 2.5, sm: 3 },
  "& .MuiButton-endIcon": { ml: 1, mr: 0 },
};

export default function UsageFiltersMenu({ source, days, onSourceChange, onDaysChange }: {
  source: UsageSource;
  days: number;
  onSourceChange: (source: UsageSource) => void;
  onDaysChange: (days: number) => void;
}) {
  const id = useId();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const product = source === "classic" ? "Go" : "Gambit";
  const choose = (action: () => void) => { action(); setAnchor(null); };
  const itemSx = { minHeight: 44, gap: 2, justifyContent: "space-between" };
  const headingSx = { bgcolor: APP_SURFACE, color: APP_TEXT_SECONDARY, lineHeight: "32px", fontSize: 12 };
  const check = <Check fontSize="small" sx={{ color: APP_ACCENT_GOLD }} />;
  return <>
    <Button aria-label={`Usage filters: ${product}, ${days} days`} aria-haspopup="menu"
      aria-expanded={!!anchor} aria-controls={anchor ? id : undefined} endIcon={<ExpandMore />}
      sx={{ ...usageFilterPillSx, ml: "auto" }}
      onClick={event => setAnchor(event.currentTarget)}>
      {product} · {days} days
    </Button>
    <Menu id={id} anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}
      MenuListProps={{ "aria-label": "Usage filters" }}
      slotProps={{ paper: { sx: { bgcolor: APP_SURFACE, color: "white", border: `1px solid ${APP_BORDER}`, borderRadius: "16px", minWidth: 220 } } }}>
      <ListSubheader sx={headingSx}>Product</ListSubheader>
      {(["gambit", "classic"] as const).map(value => <MenuItem key={value} role="menuitemradio"
        aria-checked={source === value} selected={source === value} sx={itemSx}
        onClick={() => choose(() => onSourceChange(value))}>
        {value === "gambit" ? "Gambit" : "Go"}{source === value && check}
      </MenuItem>)}
      <ListSubheader sx={headingSx}>Period</ListSubheader>
      {[7, 30].map(value => <MenuItem key={value} role="menuitemradio"
        aria-checked={days === value} selected={days === value} sx={itemSx}
        onClick={() => choose(() => onDaysChange(value))}>
        {value} days{days === value && check}
      </MenuItem>)}
    </Menu>
  </>;
}
